import EngagementTemplate from 'screens/admin/Engagement/EngagementTemplate';
import PulseKickstart from 'screens/admin/Engagement/kickstart/PulseKickstart';
import { ReviewProcessV1 } from 'screens/admin/Reviews/ReviewProcessV1';
import { ReviewProcessSelectorWrapper } from 'screens/admin/Reviews/ReviewProcessV1/ReviewProcessSelectorWrapper';
import { ReviewProcessSidebar } from 'screens/admin/Reviews/ReviewProcessV1/ReviewProcessSidebar';
import ReviewTemplate from 'screens/admin/Reviews/ReviewTemplate';
import FormsPageRabbit from 'screens/performanceReview/FormsPageRabbit';
import ResultPageChartOnly from 'screens/performanceReview/ResultPage/ResultPageChartOnly';
import ResultPageRabbit from 'screens/performanceReview/ResultPage/ResultPageRabbit';
import ReviewResultSidebar from 'screens/performanceReview/ResultPage/components/sidebar/ReviewResultSidebar';
import ReviewFormSidebar from 'screens/performanceReview/components/Sidebar/ReviewFormSidebar';

import { PULSE_KICKSTART_STEPS, REVIEW_CYCLE_STEPS } from 'constants/ProjectConstants';

import { L3_PATHS } from './routes';
import { staticRoutesWithCustomSidebar } from './staticRoutesWithCustomSidebar';

export const NON_DEER_ROUTES = {
  reviewsFormFilling: {
    route: staticRoutesWithCustomSidebar.reviewsFormFilling,
    component: FormsPageRabbit,
    label: 'Review form',
    hasSidePanel: true,
    navComponent: ReviewFormSidebar,
    l1Module: 'myData',
  },
  reviewsResultPage: {
    route: staticRoutesWithCustomSidebar.reviewsResultPage,
    component: ResultPageRabbit,
    label: 'Review result page',
    hasSidePanel: true,
    navComponent: ReviewResultSidebar,
    l1Module: 'myData',
  },
  reviewsResultPageChart: {
    route: staticRoutesWithCustomSidebar.reviewsResultChartOnlyPage,
    component: ResultPageChartOnly,
    label: 'Review result chart only page',
    hasSidePanel: false,
    navComponent: null,
    l1Module: null,
  },
  reviewCycleCreation: {
    route: staticRoutesWithCustomSidebar.reviewCycleCreation,
    component: ReviewProcessV1,
    label: 'Review cycle creation',
    hasSidePanel: true,
    navComponent: ReviewProcessSidebar,
    l1Module: 'company',
  },
  reviewCycleTemplateCreation: {
    route: staticRoutesWithCustomSidebar.reviewCycleTemplateCreation,
    component: ReviewTemplate,
    label: 'Review template Creation',
    hasSidePanel: false,
    navComponent: null,
    l1Module: 'company',
  },
  reviewCycleTemplatePreview: {
    route: staticRoutesWithCustomSidebar.reviewCycleTemplatePreview,
    component: ReviewTemplate,
    label: 'Review template preview',
    hasSidePanel: false,
    navComponent: null,
    l1Module: 'company',
  },
  engagementSurveyCreation: {
    route: staticRoutesWithCustomSidebar.engagementSurveyCreation,
    component: PulseKickstart,
    label: 'Engagement survey creation',
    hasSidePanel: false,
    navComponent: null,
    l1Module: 'company',
  },
  engagementTemplateCreation: {
    route: staticRoutesWithCustomSidebar.engagementTemplateCreation,
    component: EngagementTemplate,
    label: 'Engagement template Creation',
    hasSidePanel: false,
    navComponent: null,
    l1Module: 'company',
  },
  engagementTemplatePreview: {
    route: staticRoutesWithCustomSidebar.engagementTemplatePreview,
    component: EngagementTemplate,
    label: 'Engagement template Preview',
    hasSidePanel: false,
    navComponent: null,
    l1Module: 'company',
  },
};

export const getDeerReviewFormRoute = (reviewId: string, employeeId: string) =>
  staticRoutesWithCustomSidebar.reviewsFormFilling.replace(':reviewId', reviewId).replace(':employeeId', employeeId);

export const getDeerReviewResultRoute = (reviewId: string, employeeId: string) =>
  staticRoutesWithCustomSidebar.reviewsResultPage.replace(':reviewId', reviewId).replace(':employeeId', employeeId);

export const getDeerReviewCycleRoute = (formId: string, step: string) => {
  let route = staticRoutesWithCustomSidebar.reviewCycleCreation;
  route = route.replace(':step', step || REVIEW_CYCLE_STEPS[0]);
  return route.replace(':formId', formId);
};

export const getDeerPulseKickstartRoute = (formId: string, step: string) => {
  let route = staticRoutesWithCustomSidebar.engagementSurveyCreation;
  route = route.replace(':step', step || PULSE_KICKSTART_STEPS[0]);
  return route.replace(':formId', formId);
};

export const getDeerEngagementTemplateRoute = (templateId: string) =>
  staticRoutesWithCustomSidebar.engagementTemplateCreation.replace(':templateId', templateId);

export const getDeerEngagementTemplatePreviewRoute = (templateId: string) =>
  staticRoutesWithCustomSidebar.engagementTemplatePreview.replace(':templateId', templateId);

export const getDeerEngagementSurveyQuestionnaireRoute = (surveyId: string) =>
  L3_PATHS['my-data'].engagement.activeSurvey.replace(':surveyId', surveyId);
